export default __webpack_public_path__ + "static/media/criminal6.9791fea8.jpg";